/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".password-eye[_ngcontent-%COMP%]{position:absolute;top:21px;right:4px;color:#293846}.password-eye[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-size:17px}"];
export { styles as styles };
